import axios from 'axios';

export const api = axios.create({
  baseURL: 'http://localhost:3001/',
  timeout: 20000,
  headers: {
    Authorization: 'Bearer ' + localStorage.getItem('auth'),
  },
});
